<template>
    <div class="home">
        <div class="box">	
            <h2 class="title is-size-5">Request Details</h2>
            
            <form @submit.prevent="updateRequest">
                <div class="row columns">
                    <div class="field column">
                          <label class="label">Requestor</label>
                          <div class="control select is-fullwidth">
                              <select class="input" v-model="user_id"  required autofocus>
                                <option value="">Please select ...</option>
                               <option value="1">David Hynes</option>
                               <option value="2">Neil Williams</option>
                               <option value="2">Paul Berry</option>
                            </select>
                          </div>
                      </div>

                      <div class="field column">
                          <label class="label">Club Name </label>
                          <div class="control">
                              <input class="input" type="text" v-model="club_name"  >
                             
                          </div>
                      </div>
                    </div>
                    <div class="row columns">
                      <div class="field column ">
                          <label class="label">Request Type</label>
                          <div class="control select is-fullwidth">
                              <select class="input" v-model="request_type_id"  required >
                                <option value="">Please select ...</option>
                               <option value="1">Garments</option>
                               <option value="2">Strike Offs</option>
                               
                            </select>
                          </div>
                      </div>
      
                     
                      <div class="field column">
                          <label class="label">Potential Order Quantity </label>
                          <div class="control">
                              <input class="input" type="number" v-model="quantity" min="1" step="1" required @keypress="isNumber($event)">
                             
                          </div>
                      </div>
                    </div>
                      <div class="field">
                          <label class="label">Generic Request Instructions</label>
                          <div class="control">
                              <textarea class="textarea"  v-model="instructions" required ></textarea>
                                <small>You can add instructions for each item on the next screen</small>
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Generic Attachments (applicable for all items)</label>
                          <div class="control">
                              <p><em>Derry 2024 Crest Logo.jpg</em></p>
                              <p><em>Embroidery Photo Logo.png</em></p>
                                <input type="file" />
                          </div>
                      </div>

                      
      
                      <div class="field is-grouped mt-5">
                          <div class="control">
                              <button class="button is-success" :disabled="working===true">Update Request Details</button>
                          </div>
                      </div>
                  </form>
            
          </div>


          <div class="box">
            <button class="button is-small is-pulled-right is-success" @click="showAddItemModal=true">Add new Item</button>
            <h2 class="title is-size-5">Request Items</h2>
            <table class="table is-fullwidth is-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Garment</th>
                        <th>Type</th>
                        <th>Qty</th>
                        <th>Extras</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>1</td>
                        <td>Clodagh 060 K20 T-Shirt</td>
                        <td>Fully Printed</td>
                        <td>3</td>
                        <td class="tags">
                            <span class="tag">Emb.</span>
                            <span class="tag is-link">Trims</span>
                            <span class="tag is-link">DTF</span>
                            <span class="tag">Silcon</span>
                        </td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>Kai 179 Gaelic Micro Stripe Training Shorts</td>
                        <td>Cut/Sew</td>
                        <td>1</td>
                        <td class="tags">
                            <span class="tag is-link">Emb.</span>
                            <span class="tag ">Trims</span>
                            <span class="tag ">DTF</span>
                            <span class="tag">Silcon</span>
                        </td>
                    </tr>
                    <tr>
                        <td>3</td>
                        <td>Printed J09 Shortsleeve K5 Jersey</td>
                        <td>Strike Off</td>
                        <td>4</td>
                        <td class="tags">
                            <span class="tag is-link">Emb.</span>
                            <span class="tag ">Trims</span>
                            <span class="tag is-link">DTF</span>
                            <span class="tag is-link">Silcon</span>
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>

          <div class="modal " v-bind:class="{ 'is-active' : showAddItemModal} ">
            <div class="modal-background"></div>
            <div class="modal-card process">
                <header class="modal-card-head">
                <p class="modal-card-title">Add New Item</p>
                <button class="delete" aria-label="close" @click="showAddItemModal=false"></button>
                </header>
                <section class="modal-card-body">
                    <form @submit.prevent="updateRequest">
                       
                            <div class="field ">
                                <label class="label">Garment</label>
                                <div class="control select is-fullwidth">
                                    <select class="input" v-model="garment_id"  required >
                                        <option value="">Please select ...</option>
                                    <option  v-for="row in garments" v-bind:key="row.id">{{ row.garmentname }}</option>
                                   
                                    </select>
                                </div>
                            </div>

                           
                            <div class="field  ">
                                <label class="label">Request Type</label>
                                <div class="control select is-fullwidth">
                                    <select class="input" v-model="item_type_id"  required >
                                        <option value="">Please select ...</option>
                                    <option value="1">Fully Printed</option>
                                    <option value="2">Part Printed</option>
                                    <option value="2">Cut/Sew</option>
                                    <option value="2">Strike Off</option>
                                    </select>
                                </div>
                            </div>
            
                            <div class="field  ">
                                <label class="label">Extras</label>
                                <div class="control tags ">
                                    <span class="button tag " :class="{'is-link' : item_embroidery == true}"  @click="item_embroidery = !item_embroidery">Emb.</span>
                                    <span class="button tag " :class="{'is-link' : item_trims == true}"  @click="item_trims = !item_trims">Trims</span>
                                    <span class="button tag " :class="{'is-link' : item_dtf == true}"  @click="item_dtf = !item_dtf">DTF</span>
                                    <span class="button tag " :class="{'is-link' : item_silicon == true}"  @click="item_silicon = !item_silicon">Silicon</span>
                                </div>
                            </div>
                            
                           
                            <div class="field">
                                <label class="label">Item Instructions</label>
                                <div class="control">
                                    <textarea class="textarea"  v-model="instructions" required ></textarea>
                                        <small>You can add instructions for each item on the next screen</small>
                                </div>
                            </div>

                            <div class="field">
                                <label class="label">Item Attachments</label>
                                <div class="control">
                                    <p><em>Derry 2024 Crest Logo.jpg</em></p>
                                    <p><em>Embroidery Photo Logo.png</em></p>
                                        <input type="file" />
                                </div>
                            </div>

                            
            
                            <div class="field is-grouped mt-5">
                                <div class="control">
                                    <button class="button is-success" :disabled="working===true" @click="showAddItemModal=false">Save Item</button>
                                </div>
                            </div>
                        </form>
                </section>
            </div>
        </div>
          
      </div>
  </template>

<script>
    //import OrderService from '@/services/OrderService.js';
    import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'AddStone',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    internal_products: [],
                    internal_product_id: '',
                    description: '',
                    quantity: '',
                    unit_price: '',
                    date: this.getStartDate(),
                    working:false,
                    club_name: '',
                    num_samples: '',
                    user_id: '',
                    instructions: '',
                    showAddItemModal: false,
                    garments: [],
                    include_hidden: false,
                    item_embroidery: false,
                    item_trims: false,
                    item_dtf: false,
                    item_silicon: false
                    
                    
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
               this.getGarments();
            });
          
        },
        methods: {
            async getGarments() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "garments?include_hidden=" + this.include_hidden).then(
                    response => {
                        this.garments = response 
                        this.loading = false;
                    }
                    );
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async updateRequest() {
                alert("This will update the request details")
                
                /*
                this.working = true
                var formdata = { 
                    description : this.description,
                    internal_product_id : this.internal_product_id,
                    date : this.date,
                    quantity : this.quantity,
                    unit_price : this.unit_price
                }; 

                OrderService.saveInternalOrder(this.accessToken, formdata)
                .then((response) => {
                    this.$router.push("/finance/internal-orders");
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
                */
            },
            getStartDate() {
            
                var d = new Date();
                
                d.setDate(d.getDate() );
                return d.toISOString().slice(0,10);
                
            },
           
        }
    }
    </script>